// Экран 1 из ТЗ раздел 3.3: витрина тарифов. Backend (GET /miniapp/plans) уже не возвращает
// пробные тарифы (is_trial) — решение 2026-08-20, пробный доступ выдаётся только через /promo в
// боте, здесь его сознательно не показываем.
//
// Цена — за 1 устройство ("от"), выбор реального количества (1..plan.device_limit, скидка за
// опт) — на экране 2 «Оформление подписки», не здесь.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { ApiError, fetchPlans, type Plan } from "../api/client";

export function PlansScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [plans, setPlans] = useState<Plan[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchPlans()
      .then((data) => {
        if (!cancelled) setPlans(data);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(err instanceof ApiError ? err.message : String(err));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <h1>{t("plans_title")}</h1>
      {error && <p role="alert">{t("plans_error")}</p>}
      {!error && plans === null && <p>{t("loading")}</p>}
      {plans !== null && plans.length === 0 && <p>{t("plans_empty")}</p>}
      {plans !== null && plans.length > 0 && (
        <ul>
          {plans.map((plan) => (
            <li key={plan.id}>
              <div>
                <strong>{plan.title}</strong>
              </div>
              <div>
                {plan.price} {plan.currency}/{plan.duration_days}
                {t("days_short")}
              </div>
              <div>{t("plans_device_range", { max: plan.device_limit })}</div>
              <button type="button" onClick={() => navigate(`/checkout/${plan.id}`)}>
                {t("buy")}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
